export default __webpack_public_path__ + "static/media/NO_Cartoon.3f0cb926.jpg";